import wixLocation from 'wix-location';
import { biLoggerFactory } from 'wix-private';

const biLogger = biLoggerFactory('marketplace', 80, { msid: 'c03f75d4-ed73-4244-b7c6-c87ea8828184' });
const clickTypes = {
	applyNow: "Apply Now",
	learnMore: "Learn More",
	partnerProgram: "Partner Program",
	exploreResources: "Explore Resources",
	matchingGuideLines: "Matching Guidelines",
	profileGuide: "Profile Guide",
	generateLeads: "generate leads",
	becomeAPartner:"Become a Partner"
}

$w.onReady(async function () {
	//attach BIEvent to pageLoad
	await pageLoadStarted();
	//attach BI events to page CTA's
	await pageEvents();

});

export async function button22_click(event) {
	try {
		const biEventObject = { evid: 157, origin: 'how it works', typeid: 1 };
		biLogger.log(biEventObject);
	} catch (err) {
		console.log(err, "heree")
	}
	wixLocation.to('https://www.wix.com/arena/dynamic-brief?entry=generalMenu&serviceType=1&innerType=1&origin=arenahow')
}

export async function button_click(event) {
	try {
		const biEventObject = { evid: 156, origin: 'how it works', typeid: 1 };
		biLogger.log(biEventObject);
	} catch (err) {
		console.log(err, "heree")
	}
	wixLocation.to('https://www.wix.com/arena/hire')
}

export async function fireEvent(clickType) {
	const biEventObject = { evid: 172, clickType: clickType };
	try {
		biLogger.log(biEventObject);
		console.log("done")
	} catch (error) {
		console.log(error, "sth went wrong");
	}
}

async function pageLoadStarted (){
	try {
		const biEventObject = { evid: 181, typeid: 1 };
		biLogger.log(biEventObject);
	} catch (err) {
		console.log(err, "heree")
	}
}

async function pageEvents(){
	$w("#box27").onClick(async ()=>{
		await fireEvent(clickTypes.learnMore);
	})
	$w("#box12").onClick(async ()=>{
		await fireEvent(clickTypes.learnMore);
	})
	$w("#box3").onClick(async ()=>{
		await fireEvent(clickTypes.applyNow);
	})
	$w("#box18").onClick(async ()=>{
		await fireEvent(clickTypes.applyNow);
	})
	$w("#box1").onClick(async ()=>{
		await fireEvent(clickTypes.partnerProgram);
	})
	$w("#box24").onClick(async ()=>{
		await fireEvent(clickTypes.partnerProgram);
	})
	$w("#box25").onClick(async ()=>{
		await fireEvent(clickTypes.partnerProgram);
	})
	$w("#box26").onClick(async ()=>{
		await fireEvent(clickTypes.partnerProgram);
	})
	$w("#box28").onClick(async ()=>{
		await fireEvent(clickTypes.partnerProgram);
	})
	$w("#box29").onClick(async ()=>{
		await fireEvent(clickTypes.partnerProgram);
	})
	$w("#box22").onClick(async ()=>{
		await fireEvent(clickTypes.applyNow)
	});
	$w("#box17").onClick(async ()=>{
		await fireEvent(clickTypes.applyNow)
	});
	$w("#box23").onClick(async ()=>{
		await fireEvent(clickTypes.applyNow);
	})
	$w("#box10").onClick(async ()=>{
		await fireEvent(clickTypes.applyNow);
	})
	$w("#button72").onClick(async ()=>{
		await fireEvent(clickTypes.matchingGuideLines)
	})
	$w("#button73").onClick(async ()=>{
		await fireEvent(clickTypes.profileGuide)
	})
	$w("#box2").onClick(async ()=>{
		await fireEvent(clickTypes.generateLeads)
	})
	$w("#button76").onClick(async ()=>{
		await fireEvent(clickTypes.exploreResources)
	})
	$w("#box4").onClick(async ()=>{
		await fireEvent(clickTypes.becomeAPartner)
	})
	$w("#box6").onClick(async ()=>{
		await fireEvent(clickTypes.becomeAPartner)
	})
	$w("#box19").onClick(async ()=>{
		await fireEvent(clickTypes.becomeAPartner)
	})
	$w("#box8").onClick(async ()=>{
		await fireEvent(clickTypes.becomeAPartner)
	})
}

